import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";

const About = lazy(() => import("./pages/About"));
const TechnicalOperations = lazy(() => import("./pages/TechnicalOperations"));
const DigitalMarketing = lazy(() => import("./pages/DigitalMarketing"));
const PublicService = lazy(() => import("./pages/PublicService"));
const Publications = lazy(() => import("./pages/Publications"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Czar = lazy(() => import("./pages/Czar"));
const AppointmentConfirmed = lazy(() => import("./pages/AppointmentConfirmed"));
const ViceChair = lazy(() => import("./pages/ViceChair"));
const WorkWithMe = lazy(() => import("./pages/WorkWithMe"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Blog = lazy(() => import('./pages/Blog'));
const WhatIsDigitalExhaust = lazy(() => import('./pages/blog/WhatIsDigitalExhaust'));
const FractionalCTO = lazy(() => import('./pages/blog/FractionalCTO'));
const DataMonetizationFramework = lazy(() => import('./pages/blog/DataMonetizationFramework'));
const DigitalTransformationPlaybook = lazy(() => import('./pages/blog/DigitalTransformationPlaybook'));
const PhdEducatedToddler = lazy(() => import('./pages/blog/PhdEducatedToddler'));
const CaseStudies = lazy(() => import('./pages/CaseStudies'));
const Speaking = lazy(() => import('./pages/Speaking'));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/technical-operations" element={<TechnicalOperations />} />
            <Route path="/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/public-service" element={<PublicService />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/czar" element={<Czar />} />
            <Route path="/appointment-confirmed" element={<AppointmentConfirmed />} />
            <Route path="/public-service/vice-chair" element={<ViceChair />} />
            <Route path="/work-with-me" element={<WorkWithMe />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/what-is-digital-exhaust" element={<WhatIsDigitalExhaust />} />
            <Route path="/blog/what-is-a-fractional-cto" element={<FractionalCTO />} />
            <Route path="/blog/data-monetization-framework" element={<DataMonetizationFramework />} />
            <Route path="/blog/digital-transformation-playbook" element={<DigitalTransformationPlaybook />} />
            <Route path="/blog/phd-educated-toddler" element={<PhdEducatedToddler />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
